module.exports = __webpack_public_path__ + "static/media/plus_shadow.c4017e62.svg";